import "./assets/App.scss";
import CalorieContainer from "./components/CalorieContainer";

function App() {
  return (
    <div className="">
      <CalorieContainer />
    </div>
  );
}

export default App;
